import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import styled from "styled-components";
import Paperplane from "../components/elements/Paperplane";
import { useAuth } from "../context/auth";
import { navigate } from "@reach/router";

// const schema = yup.object().shape({
//   email: yup.string().required("please insert email"),
// });

const BackBtn = styled.button`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 2vh;
  text-align: center;
  letter-spacing: 0.005em;
  color: #fdfffc;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 20px;
  right: 3.57%;
  margin-top: 20px;
`;

const FormInput = styled.input`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: #fffcf2;
  width: 40vh;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
`;

const LoginBtn = styled.button`
  background: linear-gradient(
    90deg,
    #f89825 0%,
    #f26322 17.75%,
    #e5333b 46.66%,
    #c81d5e 86.72%,
    #a91e5e 97.37%
  );
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 50px;
  border: none;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  /* or 186% */
  color: #fdfffc;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
`;

const Header = styled.h1`
  font-family: Playfair Display;
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  margin-top: 50px;
  color: #fffcf2;
`;

const Errors = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #ff5c5c;
  margin-left: 20px;
  margin-top: 5px;
`;

export default function ForgotPassword() {
  const { ResetPassword } = useAuth();
  const BASE_URL = "https://catway.services.ombre.app/v1/";

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    // resolver: yupResolver(schema),
  });

  //   const ResetPassword = (email) => {
  //     return axios.post(BASE_URL + "auth/password-recovery", {
  //       email,
  //     });
  //   };

  const onSubmit = (data) => {
    return axios
      .post(BASE_URL + "auth/password-recovery", {
        email: data.email,
      })
      .then((res) => {
        setShowOverlay(true);
      })
      .catch((err) => {
        console.log("error");
      })
      .then(() => {
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      });
  };

  const [showOverlay, setShowOverlay] = useState(false);
  const text = "Email Sent!";
  return (
    <>
      <Paperplane active={showOverlay} text={text}>
        <div>
          <BackBtn>
            <i className="fa fa-arrow-left"></i>
          </BackBtn>
        </div>
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "16px" }}
        >
          <Header>Reset Password</Header>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "50px" }}
          >
            <FormInput
              {...register("email", {
                required: true,
                pattern: /^\S+@\S+$/,
              })}
              placeholder="Your email address"
            />
          </div>
          {errors.email && <Errors>Please enter valid email address</Errors>}
          <div style={{ marginTop: "40px" }}>
            <LoginBtn type="submit">Submit</LoginBtn>
          </div>
        </form>
      </Paperplane>
    </>
  );
}
